// JsFromRoutes CacheKey b2c0699e2e7ff8d40d19cfa673de147a
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  manageCard: /* #__PURE__ */ definePathHelper('get', '/card/manage'),
  tutorial: /* #__PURE__ */ definePathHelper('get', '/card/manage/tutorial'),
  cardActivation: /* #__PURE__ */ definePathHelper('get', '/card/manage/card_activation'),
  cardActivate: /* #__PURE__ */ definePathHelper('post', '/card/manage/card_activate'),
  guessTypeOfCard: /* #__PURE__ */ definePathHelper('post', '/card/manage/guess_type_of_card'),
  cardTransactions: /* #__PURE__ */ definePathHelper('get', '/card/manage/transactions'),
  cardDetails: /* #__PURE__ */ definePathHelper('get', '/card/manage/card_details'),
  changeCardPin: /* #__PURE__ */ definePathHelper('post', '/card/manage/change_pin'),
  lock: /* #__PURE__ */ definePathHelper('post', '/card/manage/lock'),
  unlock: /* #__PURE__ */ definePathHelper('post', '/card/manage/unlock'),
  updateCardholderInfo: /* #__PURE__ */ definePathHelper('post', '/card/manage/update_cardholder_info'),
  updateCardSettings: /* #__PURE__ */ definePathHelper('post', '/card/manage/update_card_settings'),
  requestReplacement: /* #__PURE__ */ definePathHelper('post', '/card/manage/replace'),
  requestReplacementFromLanding: /* #__PURE__ */ definePathHelper('post', '/card/manage/replace/v2'),
  requestPhysical: /* #__PURE__ */ definePathHelper('post', '/card/manage/request_physical'),
  panViewed: /* #__PURE__ */ definePathHelper('post', '/card/manage/pan_viewed'),
  initiateWalletProvisioning: /* #__PURE__ */ definePathHelper('post', '/card/manage/initiate_wallet_provisioning'),
  addToWallet: /* #__PURE__ */ definePathHelper('post', '/card/manage/add_to_wallet'),
  archive: /* #__PURE__ */ definePathHelper('put', '/card/manage/archive'),
  testOnlyCreateCard: /* #__PURE__ */ definePathHelper('post', '/card/manage/test_only_create_card'),
}
